<div oui-dialog-title>
  Modifier la section
  <oui-button class="dialog-close-btn" type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="dialog-content">
  @if (isLoading()) {
    <div class="loading-container">
      <oui-loading></oui-loading>
    </div>
  } @else {
    <span class="text-italic">Type de doument: {{ data.documentName }}</span>
    <div class="dialog-body">
      <oui-autocomplete
        label="Section du document"
        [control]="sectionControl"
        [options]="sectionOption"
        style="padding-bottom: 0.5rem"></oui-autocomplete>
    </div>
  }
</oui-dialog-content>

<oui-dialog-actions class="dialog-actions">
  <oui-button type="text" oui-dialog-close>Annuler</oui-button>
  <oui-button [type]="sectionControl.valid ? 'contained' : 'outlined'" (click)="confirm()"
    >Valider</oui-button
  >
</oui-dialog-actions>
